import { ConnectButton } from '@rainbow-me/rainbowkit'
import { CSSProperties, FC, ReactElement, useState } from 'react'
import { useDisconnect } from 'wagmi'

export const SolidButton: FC<{
  children: ReactElement | string | string[]
  onClick(): void
  disabled?: boolean
  style?: CSSProperties
  className?: string
}> = ({ children, onClick, disabled, style, className }) => {
  return (
    <button
      style={style ? { ...style } : {}}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      className={
        (className ? className + ' ' : '') +
        'py-[13px] px-[38px] bg-[#FE902A] rounded-md cursor-pointer text-white  text-xl font-black whitespace-nowrap hover:bg-[#F27502] disabled:bg-[#FE902A]/70'
      }
    >
      {children}
    </button>
  )
}

const WalletsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6013 9.1759V10.8239C17.6013 11.2639 17.2493 11.6239 16.8013 11.6399H15.2333C14.3693 11.6399 13.5773 11.0079 13.5053 10.1439C13.4573 9.6399 13.6493 9.1679 13.9853 8.8399C14.2813 8.5359 14.6893 8.35986 15.1373 8.35986H16.8013C17.2493 8.37586 17.6013 8.7359 17.6013 9.1759Z"
      fill={'#A4ABB6'}
    />
    <path
      d="M16.3776 12.84H15.2336C13.7136 12.84 12.4336 11.696 12.3056 10.24C12.2336 9.40795 12.5376 8.57595 13.1456 7.98395C13.6576 7.45595 14.3696 7.15995 15.1376 7.15995H16.3776C16.6096 7.15995 16.8016 6.96795 16.7776 6.73595C16.6016 4.79195 15.3136 3.46395 13.4016 3.23995C13.2096 3.20795 13.0096 3.19995 12.8016 3.19995H5.60156C5.37756 3.19995 5.16156 3.21595 4.95356 3.24795C2.91356 3.50395 1.60156 5.02395 1.60156 7.19995V12.8C1.60156 15.008 3.39356 16.8 5.60156 16.8H12.8016C15.0416 16.8 16.5856 15.4 16.7776 13.264C16.8016 13.032 16.6096 12.84 16.3776 12.84ZM10.4016 8.19995H5.60156C5.27356 8.19995 5.00156 7.92795 5.00156 7.59995C5.00156 7.27195 5.27356 6.99995 5.60156 6.99995H10.4016C10.7296 6.99995 11.0016 7.27195 11.0016 7.59995C11.0016 7.92795 10.7296 8.19995 10.4016 8.19995Z"
      fill={'#A4ABB6'}
    />
  </svg>
)

const Wallet: FC<{
  address: string
  isLoading: boolean
  disconnectwallet(): void
}> = ({ address, isLoading, disconnectwallet }) => {
  // disconnect wallet on click
  const [isHover, setIsHover] = useState(false)
  const onWalletDisconnect = () => {
    disconnectwallet()
    return
  }
  return (
    <div
      style={{ height: 36, backgroundColor: 'rgba(47, 48, 54, 0.26)' }}
      className="font-sans text-sm flex px-3 gap-3 items-center rounded-xl border border-[#3F4756] cursor-pointer"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onWalletDisconnect()}
    >
      <div>
        <WalletsIcon />
      </div>
      {isHover ? (
        <div className="text-center w-full text-red-500"> Disconnect </div>
      ) : (
        <div className="text-[#A4ABB6]">
          {isLoading
            ? '...'
            : `${address.slice(0, 5)}...${address.substring(
                address.length - 4
              )}`}
        </div>
      )}
    </div>
  )
}

interface IButtonProps {
  width?: number | string
  unselected?: boolean
  small?: boolean
  highlight?: boolean
  children: ReactElement | string | string[]
  style?: CSSProperties
  disabled?: boolean
  loader?: boolean

  onClick(): void
}

export const InternalSettingsButton: FC<IButtonProps> = (props) => {
  return (
    <button
      style={{
        width: props.width,
        height: props.small ? 36 : 51,
        color: props.unselected
          ? 'white'
          : props.disabled
          ? 'rgba(252, 254, 3, 0.4)'
          : '#FE902A',
        // background: props.unselected ? 'rgba(47, 48, 54, 0.26)' : 'rgba(252, 254, 3, 0.1)',
        ...props.style,
      }}
      disabled={props.disabled}
      className={`font-label rounded-md px-3 ${
        props.highlight && 'border-kap-neon border'
      } ${
        props.unselected
          ? 'bg-[#2F3036] hover:bg-[#2B2C32] active:bg-[#3F4046]'
          : 'bg-kap-neon bg-opacity-10 hover:bg-opacity-15 active:bg-opacity-20'
      }
      ${props.loader ? 'disabled:animate-pulse' : ''}
                disabled:bg-opacity-5`}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  )
}

export const ConnectWalletKapButton: FC<{
  className?: string
  // connectedWallet: string
}> = ({ className }) => {
  const [isHover, setIsHover] = useState(false)

  return (
    <ConnectButton.Custom>
      {({ account, openConnectModal }) => {
        const { disconnect } = useDisconnect()
        const connectedWallet = account?.address

        const handleClick = () => {
          if (connectedWallet) {
            disconnect()
          } else {
            openConnectModal()
          }
        }

        return connectedWallet ? (
          <Wallet
            address={connectedWallet}
            isLoading={false}
            disconnectwallet={disconnect}
          />
        ) : (
          <InternalSettingsButton
            small
            style={{
              fontSize: 16,
            }}
            width={160}
            onClick={openConnectModal}
          >
            Connect Wallet
          </InternalSettingsButton>
        )
      }}
    </ConnectButton.Custom>
  )
}

export const ConnectWalletKapSolidButton: FC<{
  className?: string
  // connectedWallet: string
}> = ({ className }) => {
  const [isHover, setIsHover] = useState(false)

  return (
    <ConnectButton.Custom>
      {({ account, openConnectModal }) => {
        const { disconnect } = useDisconnect()
        const connectedWallet = account?.address

        const handleClick = () => {
          if (connectedWallet) {
            disconnect()
          } else {
            openConnectModal()
          }
        }

        return connectedWallet ? (
          <Wallet
            address={connectedWallet}
            isLoading={false}
            disconnectwallet={disconnect}
          />
        ) : (
          <SolidButton
            // small
            style={{
              fontSize: 16,
            }}
            // width={160}
            onClick={openConnectModal}
          >
            Connect Wallet
          </SolidButton>
        )
      }}
    </ConnectButton.Custom>
  )
}
